import React from 'react';
import { DashboardLayout } from '../components/layout';
import BroadcastComposer from '../components/broadcast/BroadcastComposer';

export default function FacultyBroadcastPage() {
  return (
    <DashboardLayout title="Broadcast">
      <BroadcastComposer role="faculty" />
    </DashboardLayout>
  );
}
